import ClientCookies from 'universal-cookie';
import { GROVER_NATIVE_FLOW } from 'ggApp/utils/CookiesManager/constants';
import { isAppUser } from 'ggApp/routes/_wrap/MobileWrapper/utils';

const cookies = new ClientCookies();

export const isNativeFlowActive = (): boolean =>
    cookies.get(GROVER_NATIVE_FLOW, { doNotParse: true }) === 'true' && isAppUser();
